import { ItemView } from '../../models/item-view.model';
import { ListItem } from '../../models/list-item.model';

export class ExpandableListModel {
    private currentListItemsShown: number;
    private currentTilesShown: number;

    constructor(
        public items: Array<ListItem>,
        public showMoreAriaLabel: string,
        public showLessAriaLabel: string,
        public showMoreUpdateAriaLabel: string,
        public showLessUpdateAriaLabel: string,
        public initialListItemCount: number,
        public maxItemCount: number,
        private readonly registerImpression: (displayedItemCount: number, itemView: ItemView) => void,
        public animationOnLoad: ExpandableListLoadAnimation,
        public options?: ExpandableListOptions
    ) {
        if (typeof this.options === 'undefined') {
            this.options = {};
        }
        this.options.initialTileItemCount = this.options.initialTileItemCount || this.initialListItemCount;
        this.currentListItemsShown = this.initialListItemCount;
        this.currentTilesShown = this.options.initialTileItemCount;
    }

    public onImpression(displayedItemCount: number, itemView: ItemView) {
        this.registerImpression(displayedItemCount, itemView);
    }

    public itemsShown(expanded: boolean, showingTiles: boolean) {
        return Math.min(this.options.infiniteShowMoreEnabled ? showingTiles ? this.currentTilesShown : this.currentListItemsShown
            : expanded ? this.maxItemCount : (showingTiles ? (this.options.initialTileItemCount || this.initialListItemCount) : this.initialListItemCount), this.items.length);
    }

    public showMoreVisible(showingTiles: boolean) {
        const initialCount = showingTiles ? this.options.initialTileItemCount : this.initialListItemCount;
        return (!this.maxItemCount && initialCount < this.items.length) || (this.items.length > initialCount && initialCount < this.maxItemCount);
    }

    public infiniteShowMoreEnabledAndVisible(showingTiles: boolean): boolean {
        return (showingTiles ? this.currentTilesShown : this.currentListItemsShown) < this.items.length;
    }

    public infiniteShowMore() {
        this.currentListItemsShown += this.initialListItemCount;
        this.currentTilesShown += this.options.initialTileItemCount;
    }
}

export interface ExpandableListOptions {
    showMoreText?: string;
    showLessText?: string;
    initialTileItemCount?: number;
    infiniteShowMoreEnabled?: boolean;
    isSmallMobileCards?: boolean;
    isEvenPadding?: boolean;
    isVisualRefresh?: boolean;
}

export const enum ExpandableListLoadAnimation {
    None = 'None',
    Slide = 'Slide',

    // TODO: FadeAndScale does not work on Safari due to a bug with Angular 6 animations. Once this is fixed, remove the code in expandable-list.component.ts that checks for this.
    // https://github.com/angular/angular/issues/24490
    FadeAndScale = 'FadeAndScale'
}
